import { AnnotationControls } from "@/components/flow/build/AnnotationControls";
import { Chip } from "@scripts/react/components/Chip";
import { useFlowState } from "@/hooks/useFlowState";
import { BuildSteps } from "@/types/flows";

export const FileControls = ({
    filename,
    flowLocked,
    isShareMode = false
}: {
    filename?: string;
    flowLocked: boolean;
    isShareMode?: boolean;
}) => {
    const { step } = useFlowState();
    const isReviewStep = step === BuildSteps.REVIEW;

    return (
        <div className="fileCarouselHeader relative z-40">
            <div className="flex items-center gap-2">
                <h3 className="text-xs font-medium text-primary">
                    {filename || "No file selected"}
                </h3>
                {isReviewStep && (
                    <Chip type="text" className="text-xxs">
                        Draft
                    </Chip>
                )}
            </div>
            <AnnotationControls />
        </div>
    );
};
